export default "__VITE_ASSET__DuVOCgXN__"